import { captureMessage } from "@sentry/nextjs";
import { useState, useRef, useEffect } from "react";

export const useDataLayer = () => {
  const [dataLayerLoaded, setDataLayerLoaded] = useState(false);
  const dataLayerInterval = useRef<NodeJS.Timeout>(undefined);
  const dataLayerTimeout = useRef<number>(0);
  const [result, setResult] = useState<{
    ready: boolean;
    dataLayer: Window["dataLayer"];
  }>({ ready: false, dataLayer: null });

  useEffect(() => {
    // Ready means events can be queued, not that the GTM network script loaded.
    // Consent initialization may create this queue before GTM consumes it.
    if (window.dataLayer) {
      setResult({
        ready: true,
        dataLayer: window.dataLayer,
      });
    } else if (!dataLayerInterval.current) {
      /**
       * On pages that are SSR (the program page), the impression happens faster
       * than dataLayer loads. Wait for up to 10 seconds for it to load, or give up
       * and log it.
       */
      dataLayerInterval.current = setInterval(() => {
        dataLayerTimeout.current += 200;
        if (window.dataLayer && !dataLayerLoaded) {
          setDataLayerLoaded(true);
          clearInterval(dataLayerInterval.current);
        } else if (dataLayerTimeout.current >= 10000) {
          clearInterval(dataLayerInterval.current);
          captureMessage("useDreamSearchImpression: Timed out looking for dataLayer", "error");
        }
      }, 200);
    }
  }, [dataLayerLoaded]);

  return result;
};
